import {
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import TransacAddTenant from "../../components/Transaction/TransacAddTenant";
import { useModal } from "../../hooks/use-modal.jsx";
import useTenants from "../../hooks/use-tenants";
import TenantShow from "../../components/Tenant/TenantShow";
import useTransactions from "../../hooks/use-transactions";
import { useTenantBalances } from "../../hooks/use-balances";
import { TenantStatus } from "../../models/tenant_old.js";
import { BalanceDomain } from "../../utils/constants/balances";

const CANDIDAT_STATUSES = [
  TenantStatus.Candidat.status,
  TenantStatus.CandidatArchive.status,
];

export default function ShowPage() {
  const nav = useNavigate();
  const location = useLocation();

  const { tenantId } = useParams();

  const { tenantsById, updateTenant, deleteTenant, declineCandidat } =
    useTenants({
      withById: true,
    });

  const tenant = tenantsById[parseInt(tenantId)];

  const [TransacSyncModal, closeTransacSyncModal, openTransacSyncModal] =
    useModal();

  const { balances, refreshBalances } = useTenantBalances(tenantId, false);
  const {
    transactions: unlinkedTransactions,
    refreshTransactions,
    assignMultipleTransactions,
  } = useTransactions({
    path: "unlinked",
    params: { id_tenant: parseInt(tenantId) },
  });

  function syncUnlinkedTransactions() {
    return refreshTransactions()
      .then((unlinkedTransactions) => {
        if (unlinkedTransactions.length > 0) {
          openTransacSyncModal();
        }
      })
      .catch((e) => console.error(e));
  }

  async function refuserCandidat(notifyCandidat) {
    await declineCandidat(tenant.id, notifyCandidat);
    nav("/bailleur/candidats");
  }

  async function activerCandidat() {
    try {
      await updateTenant(tenant.id, { status: TenantStatus.Candidat.status });
    } catch (e) {
      console.error(e);
    }
  }

  async function activerLocataire() {
    try {
      await updateTenant(tenant.id, { status: TenantStatus.Actif.status });
    } catch (e) {
      console.error(e);
    }
  }

  async function supprimerCandidat() {
    try {
      await deleteTenant(tenant.id);
      nav("/bailleur/candidats?tab-candidat-list=candidatsArchives");
    } catch (e) {
      console.error(e);
    }
  }

  // La fiche est servie par les deux routes (/tenants et /candidats) : on
  // redirige vers celle qui correspond au statut pour que la barre latérale
  // et le fil d'ariane restent cohérents.
  const isCandidat = tenant && CANDIDAT_STATUSES.includes(tenant.status);
  if (
    tenant &&
    isCandidat &&
    location.pathname.includes("/bailleur/tenants/")
  ) {
    return (
      <Navigate
        replace
        to={{
          pathname: location.pathname.replace(
            "/bailleur/tenants/",
            "/bailleur/candidats/",
          ),
          search: location.search,
        }}
      />
    );
  }
  if (
    tenant &&
    !isCandidat &&
    location.pathname.includes("/bailleur/candidats/")
  ) {
    return (
      <Navigate
        replace
        to={{
          pathname: location.pathname.replace(
            "/bailleur/candidats/",
            "/bailleur/tenants/",
          ),
          search: location.search,
        }}
      />
    );
  }

  async function transactionUpdateHandler(selectedTransactionIds) {
    const data = {
      id_tenant: parseInt(tenantId),
      domaine: BalanceDomain.TENANT,
    };

    try {
      await assignMultipleTransactions(selectedTransactionIds, data);
      refreshBalances();
      closeTransacSyncModal();
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <>
      <TenantShow
        tenant={tenant}
        balances={balances}
        syncTransactionHandler={syncUnlinkedTransactions}
        activerCandidat={activerCandidat}
        refuserCandidat={refuserCandidat}
        activerLocataire={activerLocataire}
        supprimerCandidat={supprimerCandidat}
      />
      <Outlet />
      <TransacSyncModal size="big">
        <TransacAddTenant
          transactions={unlinkedTransactions}
          onTransactionUpdate={transactionUpdateHandler}
        />
      </TransacSyncModal>
    </>
  );
}
